import { useLingui } from '@lingui/react/macro';

// Коды описаний погод https://openweathermap.org/weather-conditions#weather-condition-codes
export const useWeatherTranslations = (id: number) => {
  const { t } = useLingui();

  switch (id) {
    // 2xx: Thunderstorm
    case 200:
      return t`Thunderstorm with light rain`;
    case 201:
      return t`Thunderstorm with rain`;
    case 202:
      return t`Thunderstorm with heavy rain`;
    case 210:
      return t`Light thunderstorm`;
    case 211:
      return t`Thunderstorm`;
    case 212:
      return t`Heavy thunderstorm`;
    case 221:
      return t`Ragged thunderstorm`;
    case 230:
      return t`Thunderstorm with light drizzle`;
    case 231:
      return t`Thunderstorm with drizzle`;
    case 232:
      return t`Thunderstorm with heavy drizzle`;
    // 3xx: Drizzle
    case 300:
      return t`Light intensity drizzle`;
    case 301:
      return t`Drizzle`;
    case 302:
      return t`Heavy intensity drizzle`;
    case 310:
      return t`Light intensity drizzle rain`;
    case 311:
      return t`Drizzle rain`;
    case 312:
      return t`Heavy intensity drizzle rain`;
    case 313:
      return t`Shower rain and drizzle`;
    case 314:
      return t`Heavy shower rain and drizzle`;
    case 321:
      return t`Shower drizzle`;
    // 5xx: Rain
    case 500:
      return t`Light rain`;
    case 501:
      return t`Moderate rain`;
    case 502:
      return t`Heavy intensity rain`;
    case 503:
      return t`Very heavy rain`;
    case 504:
      return t`Extreme rain`;
    case 511:
      return t`Freezing rain`;
    case 520:
      return t`Light intensity shower rain`;
    case 521:
      return t`Shower rain`;
    case 522:
      return t`Heavy intensity shower rain`;
    case 531:
      return t`Ragged shower rain`;
    // 6xx: Snow
    case 600:
      return t`Light snow`;
    case 601:
      return t`Snow`;
    case 602:
      return t`Heavy snow`;
    case 611:
      return t`Sleet`;
    case 612:
      return t`Shower sleet`;
    case 613:
      return t`Light rain and snow`;
    case 614:
      return t`Rain and snow`;
    case 615:
      return t`Light shower snow`;
    case 616:
      return t`Shower snow`;
    case 620:
      return t`Light snow showers`;
    case 621:
      return t`Snow showers`;
    case 622:
      return t`Heavy snow showers`;
    // 7xx: Atmosphere
    case 701:
      return t`Mist`;
    case 711:
      return t`Smoke`;
    case 721:
      return t`Haze`;
    case 731:
      return t`Sand/dust whirls`;
    case 741:
      return t`Fog`;
    case 751:
      return t`Sand`;
    case 761:
      return t`Dust`;
    case 762:
      return t`Volcanic ash`;
    case 771:
      return t`Squalls`;
    case 781:
      return t`Tornado`;
    // 8xx: Sky
    case 800:
      return t`Clear sky`;
    case 801:
      return t`Few clouds`;
    case 802:
      return t`Scattered clouds`;
    case 803:
      return t`Broken clouds`;
    case 804:
      return t`Overcast clouds`;
    default:
      return '';
  }
};
